import { render, staticRenderFns } from "./DialogContent.vue?vue&type=template&id=1618b9a9&scoped=true&"
import script from "./DialogContent.vue?vue&type=script&lang=ts&"
export * from "./DialogContent.vue?vue&type=script&lang=ts&"
import style0 from "./DialogContent.vue?vue&type=style&index=0&id=1618b9a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1618b9a9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
